import {DefaultRootState, useSelector} from 'react-redux';
import {useSet} from './set';
import {DependencyList} from 'react';

export function useSetSelector<TState = DefaultRootState, TSelected = unknown>(
    selector: (state: TState) => TSelected[],
    setSelector?: (selected: TSelected) => string,
    deps?: DependencyList) {
    return useSet(useSelector(selector), setSelector, deps);
}
